import React from 'react';
import PropTypes from 'prop-types';
import RoomIcon from '@material-ui/icons/Room';
import Typography from '@material-ui/core/Typography';
import T from 'i18n-react';
import Skeleton from '@material-ui/lab/Skeleton';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  root: {
    color: theme.props.text.primary.main,
    lineHeight: 'inherit',
  },
  icon: {
    verticalAlign: 'sub',
    marginRight: theme.spacing(0.5),
  },
});

class LocationSubheader extends React.Component {
  render() {
    const { classes, loaded, region, city, cityKana } = this.props;
    return loaded ? (
      <Typography className={classes.root}>
        <RoomIcon fontSize="small" color="inherit" className={classes.icon} />
        <T.span text={{ key: 'business.address.short', region, city }} />
        {!!cityKana && (
          <T.span text={{ key: 'business.address.kana', kana: cityKana }} />
        )}
      </Typography>
    ) : (
      <Skeleton width="95%" height={24} style={{ maxWidth: 240 }} />
    );
  }
}

LocationSubheader.propTypes = {
  loaded: PropTypes.bool,
  region: PropTypes.string,
  city: PropTypes.string,
  cityKana: PropTypes.string,
};

export default withStyles(styles)(LocationSubheader);
